/*
 * Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import { defineStore } from 'pinia';
import Axios from '@auth/vue-share/utility/axios';

export const useStatisticsStore = defineStore('statistics', {
    state: () => ({
        statistic: undefined
    }),
    getters: {
        getStatistic: (state) => state.statistic
    },
    actions: {
        fetchStatistic(start, end) {
            return new Promise((resolve, reject) => {
                Axios.post('statistic/span', '/api/statistics', {
                    start,
                    end
                })
                    .then((response) => {
                        this.statistic = response.data.data;
                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    }
});
